import React from "react";

const Archive = props => {
  return (
    <svg width="20" height="18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#838383" d="M1 4h18v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4z" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeWidth="2"
          d="M6.5 10h7"
        />
        <path fill="#838383" d="M0 3h20V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v1z" />
      </g>
    </svg>
  );
};

export default Archive;
